module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/366547fb2c98d87c8e41862fec4885b0.gif";